export default "__VITE_ASSET__p7n7MPQT__"